import { TextButton } from "../../../ui/Button/Buttons";
import { Toggle } from "../../../ui/Toggle/Toggle";

type NotificationActionsProps = {
  onMarkAllAsRead: () => void;
  showUnreadOnly: boolean;
  setShowUnreadOnly: (value: boolean) => void;
  disableMarkAllAsRead?: boolean;
};

export function NotificationActions({ 
  onMarkAllAsRead, 
  showUnreadOnly, 
  setShowUnreadOnly,
  disableMarkAllAsRead = false
}: NotificationActionsProps) {
  return (
    <div className="flex items-center justify-end gap-4">
      <Toggle
        checked={showUnreadOnly}
        onChange={() => setShowUnreadOnly(!showUnreadOnly)}
        label="Only show unread"
        checkedBgColor="bg-purple-700"
      />
      <TextButton
        onClick={onMarkAllAsRead}
        disabled={disableMarkAllAsRead}
      >
        Mark All as Read
      </TextButton>
    </div>
  );
}

